import { AppThunk } from "../types";
import { addNotificationKey, addNotificationOnPIP } from "../notificationsWindow";
import { notification } from "../../components/antd/Notification";
import { FormattedMessage } from "react-intl";
import { InfoIconOutlined } from "../../components/icons/material";
import React from "react";
export function sendCaptionTabNotification(task: string, title: string, url: string): AppThunk {
  return async dispatch => {
    const key = "caption-tab-notification";

    dispatch(
      addNotificationOnPIP({
        notificationsType: key,
        data: {
          task,
          title,
          url,
        },
      }),
    );

    dispatch(addNotificationKey(key));

    notification.open({
      key,
      icon: <InfoIconOutlined />,
      type: "meeting",
      message: <FormattedMessage id="caption-tab/notification" defaultMessage="Media Update" />,
      description: (() => {
        switch (task) {
          case "transcription":
            return (
              <FormattedMessage
                id="caption-tab/transcript-notification"
                defaultMessage='Video with transcription for "{title}" is ready. Click <link> here</link> to view.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          case "transcription-failure":
            return (
              <FormattedMessage
                id="caption-tab/transcript-failure-notification"
                defaultMessage='Video with transcription for "{title}" fails. Click <link> here</link> to retry.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          case "translation":
            return (
              <FormattedMessage
                id="caption-tab/translate-notification"
                defaultMessage='Your translation for "{title}" is now ready. Click <link> here</link> to view.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          case "translation-failure":
            return (
              <FormattedMessage
                id="caption-tab/translation-failure-notification"
                defaultMessage='Video with translation for "{title}" fails. Click <link> here</link> to retry.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          case "embedding":
            return (
              <FormattedMessage
                id="caption-tab/embedding-notification"
                defaultMessage='Video embedded with subtitle for "{title}" is ready. Click <link> here</link> to view.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          case "embedding-failure":
            return (
              <FormattedMessage
                id="caption-tab/embedding-failure-notification"
                defaultMessage='Video embedded with subtitle for "{title}" fails. Click <link> here</link> to retry.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          case "dubbing":
            return (
              <FormattedMessage
                id="caption-tab/dubbing-notification"
                defaultMessage='Video dubbed for "{title}" is ready. Click <link> here</link> to view.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          case "dubbing-failure":
            return (
              <FormattedMessage
                id="caption-tab/dubbing-failure-notification"
                defaultMessage='Video dubbed for "{title}" fails. Click <link> here</link> to retry.'
                values={{
                  title,
                  link: (chunks: string) => (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {chunks}
                    </a>
                  ),
                }}
              />
            );
          default:
            break;
        }
      })(),
    });
  };
}
